/**
 * Resolves which social login buttons should be rendered.
 *
 * The backend answers 503 on a login redirect when a provider has no
 * credentials, so the buttons are hidden until availability is known.
 */

import { useEffect, useState } from 'react'
import { fetchAuthProviders } from '@/services/api'
import type { AuthProviders } from '@/types/auth'

const NONE_AVAILABLE: AuthProviders = { google: false, facebook: false }

export function useAuthProviders(): AuthProviders {
    const [providers, setProviders] = useState<AuthProviders>(NONE_AVAILABLE)

    useEffect(() => {
        let active = true
        fetchAuthProviders()
            .then((result) => {
                if (active) setProviders(result)
            })
            .catch(() => {
                if (active) setProviders(NONE_AVAILABLE)
            })
        return () => {
            active = false
        }
    }, [])

    return providers
}
